'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = AliasesEntitySelectDirective;

require('./aliases-entity-select.scss');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _aliasesEntitySelectButtonTpl = require('./aliases-entity-select-button.tpl.html');

var _aliasesEntitySelectButtonTpl2 = _interopRequireDefault(_aliasesEntitySelectButtonTpl);

var _aliasesEntitySelectPanelTpl = require('./aliases-entity-select-panel.tpl.html');

var _aliasesEntitySelectPanelTpl2 = _interopRequireDefault(_aliasesEntitySelectPanelTpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-enable import/no-unresolved, import/default */

/* eslint-disable angular/angularelement */
/*@ngInject*/


/* eslint-disable import/no-unresolved, import/default */

/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function AliasesEntitySelectDirective($compile, $templateCache, $mdMedia, types, $mdPanel, $document, $translate) {

    var linker = function linker(scope, element, attrs) {

        /* tbAliasesEntitySelect (ng-model)
         * {
         *    "aliasId": {
         *        alias: alias,
         *        entityType: entityType,
         *        entityId: entityId
         *    }
         * }
         */

        var template = $templateCache.get(_aliasesEntitySelectButtonTpl2.default);

        scope.tooltipDirection = angular.isDefined(attrs.tooltipDirection) ? attrs.tooltipDirection : 'top';

        element.html(template);

        scope.openEditMode = function (event) {
            if (scope.disabled) {
                return;
            }
            var position;
            var panelHeight = $mdMedia('min-height: 350px') ? 250 : 150;
            var panelWidth = 300;
            var offset = element[0].getBoundingClientRect();
            var bottomY = offset.bottom - (0, _jquery2.default)(window).scrollTop(); //eslint-disable-line
            var leftX = offset.left - (0, _jquery2.default)(window).scrollLeft(); //eslint-disable-line
            var yPosition;
            var xPosition;
            if (bottomY + panelHeight > (0, _jquery2.default)(window).height()) {
                //eslint-disable-line
                yPosition = $mdPanel.yPosition.ABOVE;
            } else {
                yPosition = $mdPanel.yPosition.BELOW;
            }
            if (leftX + panelWidth > (0, _jquery2.default)(window).width()) {
                //eslint-disable-line
                xPosition = $mdPanel.xPosition.CENTER;
            } else {
                xPosition = $mdPanel.xPosition.ALIGN_START;
            }
            position = $mdPanel.newPanelPosition().relativeTo(element).addPanelPosition(xPosition, yPosition);
            var config = {
                attachTo: angular.element($document[0].body),
                controller: 'AliasesEntitySelectPanelController',
                controllerAs: 'vm',
                templateUrl: _aliasesEntitySelectPanelTpl2.default,
                panelClass: 'tb-aliases-entity-select-panel',
                position: position,
                fullscreen: false,
                locals: {
                    'aliasController': scope.aliasController,
                    'onEntityAliasesUpdate': function onEntityAliasesUpdate() {
                        scope.updateView();
                    }
                },
                openFrom: event,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: false
            };
            $mdPanel.open(config);
        };

        scope.$on('entityAliasesChanged', function () {
            scope.updateView();
        });

        scope.$on('entityAliasResolved', function () {
            scope.updateView();
        });

        scope.updateView = function () {
            updateDisplayValue();
        };

        function updateDisplayValue() {
            var displayValue;
            var singleValue = true;
            var currentAliasId;
            var entityAliases = scope.aliasController.getEntityAliases();
            for (var aliasId in entityAliases) {
                var entityAlias = entityAliases[aliasId];
                if (!entityAlias.filter.resolveMultiple) {
                    var resolvedAlias = scope.aliasController.getInstantAliasInfo(aliasId);
                    if (resolvedAlias && resolvedAlias.currentEntity) {
                        if (!currentAliasId) {
                            currentAliasId = aliasId;
                        } else {
                            singleValue = false;
                            break;
                        }
                    }
                }
            }
            if (singleValue && currentAliasId) {
                var aliasInfo = scope.aliasController.getInstantAliasInfo(currentAliasId);
                displayValue = aliasInfo.currentEntity.name;
            } else {
                displayValue = $translate.instant('entity.entities');
            }
            scope.displayValue = displayValue;
        }

        $compile(element.contents())(scope);
    };

    return {
        restrict: "E",
        scope: {
            aliasController: '='
        },
        link: linker
    };
}

/* eslint-enable angular/angularelement */


// WEBPACK FOOTER //
// ./src/app/entity/alias/aliases-entity-select.directive.js